import { render, staticRenderFns } from "./RouterDownloads.vue?vue&type=template&id=60da4cc5&scoped=true&"
import script from "./RouterDownloads.vue?vue&type=script&lang=ts&"
export * from "./RouterDownloads.vue?vue&type=script&lang=ts&"
import style0 from "./RouterDownloads.vue?vue&type=style&index=0&id=60da4cc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60da4cc5",
  null
  
)

export default component.exports